import logoImg from '../assets/logo.png';
import { company, emailHref, phoneHref } from '../data/company';
import './Footer.css';

export default function Footer() {
  const { organization, contacts } = company;
  return (
    <footer className="user-footer">
      <div className="user-footer-inner">
        <div className="user-footer-company">
          <a className="user-footer-brand" href="/" aria-label="На главную">
            <img src={logoImg} alt="Ксюник" width="64" height="48" />
          </a>
          <p className="user-footer-name">{organization.full_name}</p>
          <p>Оператор платформы</p>
          <dl className="user-footer-identifiers">
            <div><dt>ИНН</dt><dd>{organization.inn}</dd></div>
            <div><dt>КПП</dt><dd>{organization.kpp}</dd></div>
            <div><dt>ОГРН</dt><dd>{organization.ogrn}</dd></div>
          </dl>
          <p>Юридический адрес: {organization.legal_address}</p>
        </div>
        <nav className="user-footer-nav" aria-label="Информация покупателю">
          <h2>Покупателям</h2>
          <a href="/contacts">Контакты и реквизиты</a>
          <a href="/payment">Оплата</a>
          <a href="/delivery">Доставка</a>
          <a href="/returns">Возврат и отмена</a>
          <a href="/offer">Публичная оферта</a>
          <a href="/privacy/">Политика обработки персональных данных</a>
          <a href="/terms/">Условия использования</a>
          <a href="/delete-account/">Удаление аккаунта и данных</a>
        </nav>
        <address className="user-footer-contacts">
          <h2>Связаться с нами</h2>
          <a href={phoneHref}>{contacts.phone_display}</a>
          <a href={emailHref}>{contacts.email}</a>
          <p>По вопросам сервиса, заказов и возвратов</p>
        </address>
      </div>
      <div className="user-footer-bottom">© {new Date().getFullYear()} {organization.short_name}. Все права защищены.</div>
    </footer>
  );
}
